import PageBannerWithCta from './PageBannerWithCta';

export default PageBannerWithCta;
